module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_3-ad3225ab6f4aa1b529d7d38495f34a8a.jpg";